<template>
    <ValidationProvider :name="label" :rules="rules" v-slot="{ errors, required }" slim>
        <div class="migrol-form__input-wrapper" :class="{ 'migrol-form__input-wrapper--error' : errors.length > 0 }">
            <label :for="$id('input')" class="migrol-form__input-label" v-if="label && showlabel">{{label}}{{(required ? '*' : '')}}</label>
            <div class="migrol-form__input-container migrol-form__checkbox-list" :class="ComputedClass">
                <Checkbox v-for="option in options"
                             :key="option.value"
                             :checkboxValue="option.value"
                             v-model="innerValue"
                             :label="option.text"
                             :type="type"
                             :disabled="disabled" />
            </div>
            <div class="migrol-form__error-message">{{errors[0]}}</div>
        </div>
    </ValidationProvider>
</template>

<script>
    import { ValidationProvider } from 'VeeValidate';
    import Checkbox from './Checkbox';

    export default {
        inheritAttrs: false,
        model: {
            event: 'change'
        },
        props: {
            label: {
            },
            options: {
                type: Array,
                required: true
            },
            value: {
                default: null
            },
            type: {
                type: String,
                default: 'checkbox',
                required: false
            },
            display: {
                type: String,
                required: false
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            rules: {
                type: [Object, String],
                default: null,
                required: false
            },
            showlabel: {
                type: Boolean,
                required: false,
                default: true
            },
        },
        computed: {
            ComputedClass() {
                if (this.display)
                    return 'migrol-form__input-container--' + this.display;
                return '';
            }
        },
        data() {
            return {
                innerValue: []
            }
        },
        watch: {
            value:
            {
                immediate: true,
                handler(newValue) {
                    this.innerValue = newValue;
                }
            },
            innerValue(newValue) {
                this.$emit('change', newValue);
            }
        },
        components: {
            ValidationProvider,
            Checkbox
        }
    };
</script>